<template>
  <div>
    <div class="mobile-header">
      <img src="@/assets/img/mobile_home/顶部栏色块.png" class="m-header-bg" />
      <div class="m-header-content">
        <img v-if="!showBack" src="@/assets/img/mobile_home/汉堡菜单.png" class="m-hamburger" @click="handelMenu" />
        <div v-else class="m-back-btn" @click="$emit('back')">
          <img src="@/assets/img/user/back.png" />
        </div>
        <img src="@/assets/img/mobile_home/LOGO.png" class="m-logo" />
        <img v-if="!userInfo" src="@/assets/img/mobile_home/Login.png" class="m-login-btn" @click="goLogin" />
        <div v-else class="m-user-avatar" @click="showMobileUserMenu = true">
          <div class="m-header-avatar-stage" :class="{ 'has-avatar-frame': !!userInfo.headframe }">
            <img :src="userInfo.headimg || defaultAvatar" class="m-header-avatar-img" />
            <img v-if="userInfo.headframe" :src="userInfo.headframe" class="m-header-avatar-frame" />
          </div>
          <span class="m-header-user-dots" aria-hidden="true">⋮</span>
        </div>
      </div>
      
      <!-- Mobile Menu Dropdown -->
      <div class="m-menu-dropdown" v-if="showMenu">
        <img src="@/assets/img/mobile_home/弹窗部分/点击汉堡菜单之后的下拉背景.png" class="m-menu-bg" />
        <div class="m-menu-content">
          <div class="m-menu-item" @click="goPage('/')">
            <span class="m-menu-text" :class="{ 'is-active': route?.path === '/' }">Home</span>
          </div>
          <img src="@/assets/img/mobile_home/弹窗部分/下拉背景上的线.png" class="m-menu-divider" />
          
          <div class="m-menu-item" @click="goPage('/channel')">
            <span class="m-menu-text" :class="{ 'is-active': route?.path === '/channel' }">INFO</span>
          </div>
          <img src="@/assets/img/mobile_home/弹窗部分/下拉背景上的线.png" class="m-menu-divider" />
          
          <div class="m-menu-item" @click="goPage('/points_shop_page')">
            <span class="m-menu-text" :class="{ 'is-active': route?.path === '/points_shop_page' }">Points Store</span>
          </div>
          <img src="@/assets/img/mobile_home/弹窗部分/下拉背景上的线.png" class="m-menu-divider" />
          
          <div class="m-menu-item" @click="goPage('/pay')">
            <span class="m-menu-text" :class="{ 'is-active': route?.path === '/pay' }">Top-Up</span>
          </div>
          <img src="@/assets/img/mobile_home/弹窗部分/下拉背景上的线.png" class="m-menu-divider" />
          
          <div class="m-menu-item" @click="goPage('/info')">
            <span class="m-menu-text" :class="{ 'is-active': route?.path === '/info' }">User Centre</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile User Info Popup -->
    <div class="m-user-popup-overlay" v-if="showMobileUserMenu" @click="showMobileUserMenu = false">
      <div class="m-user-popup" @click.stop>
        <div class="m-user-popup-top">
          <div class="m-user-popup-avatar-wrapper" @click="editProfile('headimg')">
            <img :src="userInfo?.headimg || defaultAvatar" class="m-user-popup-avatar" />
            <img v-if="userInfo?.headframe" :src="userInfo.headframe" class="m-user-popup-avatar-frame" />
            <img src="@/assets/img/web_user/05用户中心/头像编辑.png" class="m-user-popup-avatar-edit" />
          </div>
          <div class="m-user-popup-details">
            <div class="m-user-popup-name-row">
              <span class="m-user-popup-name">{{ userInfo?.rname || userInfo?.nick || userInfo?.uname }}</span>
              <img src="@/assets/img/web_user/05用户中心/头像编辑.png" class="m-user-popup-edit" @click="editProfile('nickname')" />
            </div>
            <div class="m-user-popup-badges">
              <img v-if="userInfo?.viplevel !== undefined" :src="getVipImage(userInfo.viplevel)" class="m-user-popup-vip" />
              <img v-if="userInfo?.title" :src="userInfo.title" class="m-user-popup-title" />
            </div>
          </div>
        </div>
        <div class="m-user-popup-exp">
          <div class="m-exp-bar-wrapper">
            <div class="m-exp-bar-inner-container" :style="{ width: Math.min(((userInfo?.vipNowExe || 0) / (userInfo?.vipMaxExe || 1)) * 100, 100) + '%' }"></div>
          </div>
          <div class="m-exp-text">{{ userInfo?.vipNowExe || 0 }}/{{ userInfo?.vipMaxExe || 10000 }}EXP</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useInfoStore } from '@/stores/counter.js'
import defaultAvatar from '@/assets/img/web_home/弹窗切图/信息卡上大头像/1.png'

const props = defineProps({
  showBack: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['back', 'edit-profile'])

const route = useRoute()
const router = useRouter()
const userStore = useInfoStore()

const userInfo = computed(() => {
  return userStore.userInfo
})

const showMenu = ref(false)
const showMobileUserMenu = ref(false)

const handelMenu = () => {
  showMenu.value = !showMenu.value
}

const goLogin = () => {
  userStore.setShowLoginModal(true)
}

const goPage = (path) => {
  showMenu.value = false
  router.push(path)
}

const editProfile = (type) => {
  showMobileUserMenu.value = false
  if (route.path === '/info') {
    emit('edit-profile', type)
    return
  }

  router.push({
    path: '/info',
    query: {
      profileEdit: type
    }
  })
}

const getVipImage = (level) => {
  level = Math.min(8, Math.max(0, Number(level) || 0))
  return new URL(`../../assets/img/web_user/05用户中心/VIP${level}.png`, import.meta.url).href
  return new URL(`../../assets/img/web_home/弹窗切图/VIP${level}@2x.png`, import.meta.url).href
}
</script>

<style scoped>
.mobile-header {
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.m-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.m-header-content {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 15px;
}

.m-hamburger {
  width: 35px;
}
.m-back-btn {
  width: 32px;
  height: 32px;
  background-color: #ffcc00;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.m-back-btn img {
  width: 10px;
  height: 16px;
}
.m-logo {
  height: 40px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.m-login-btn {
  height: 30px;
  width: auto;
}

/* Mobile Menu Dropdown */
.m-menu-dropdown {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  z-index: 100;
}
.m-menu-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
}
.m-menu-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0 20px;
}
.m-menu-item {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 15px 0;
  cursor: pointer;
}
.m-menu-icon {
  height: 20px;
}
.m-menu-text {
  color: #facc15;
  font-size: 16px;
  font-weight: bold;
}
.m-menu-text.is-active {
  color: #facc15;
}
.m-menu-divider {
  width: 90%;
  height: 2px;
  opacity: 0.5;
}

/* Mobile User Popup Overlay */
.m-user-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.m-user-popup {
  position: relative;
  width: 300px;
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.m-user-popup-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.m-user-popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 2;
}
.m-user-popup-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px 20px 20px;
  z-index: 1;
}
.m-user-popup-top {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.m-user-popup-avatar-wrapper {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid #ffcc00;
  padding: 2px;
  flex-shrink: 0;
}
.m-user-popup-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
.m-user-popup-details {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 5px;
}
.m-user-popup-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.m-user-popup-name {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
.m-user-popup-vip {
  height: 20px;
}
.m-user-popup-uid {
  color: #666;
  font-size: 12px;
}
.m-user-popup-exp {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
}
.m-exp-bar-wrapper {
  position: relative;
  width: 100px;
  height: 10px;
}
.m-exp-bar-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.m-exp-bar-inner-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
  border-radius: 5px;
}
.m-exp-bar-inner {
  height: 100%;
  width: 100px;
  object-fit: cover;
  object-position: left;
}
.m-exp-text {
  color: #fff;
  font-size: 10px;
  background-color: #f16925;
  padding: 2px 6px;
  border-radius: 10px;
  white-space: nowrap;
}
.m-user-popup-buttons {
  display: flex;
  justify-content: center;
  width: 100%;
}
.m-user-popup-btn {
  height: 40px;
  cursor: pointer;
}

/* Compact account card shown below the mobile navigation bar */
.m-user-avatar {
  position: relative;
  width: 52px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.m-header-avatar-stage {
  position: relative;
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
}
.m-header-avatar-img {
  position: absolute;
  left: 3%;
  top: 3%;
  width: 94%;
  height: 94%;
  box-sizing: border-box;
  border: 2px solid #e2b93a;
  border-radius: 50%;
  object-fit: cover;
}
.m-header-avatar-stage.has-avatar-frame .m-header-avatar-img {
  left: 12%;
  top: 12%;
  width: 76%;
  height: 76%;
  border: 0;
}
.m-header-avatar-frame {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
  z-index: 2;
}
.m-header-user-dots {
  display: block;
  margin-left: 2px;
  color: #f6c232;
  font-size: 31px;
  font-weight: 900;
  line-height: 1;
  transform: translateY(-1px);
  pointer-events: none;
}
.m-user-popup-overlay {
  align-items: flex-start;
  justify-content: center;
  padding-top: 64px;
  background: transparent;
}
.m-user-popup {
  box-sizing: border-box;
  width: calc(100vw - 20px);
  max-width: 430px;
  height: 124px;
  padding: 10px 14px 8px;
  display: block;
  border: 2px solid #b8941c;
  border-radius: 10px;
  background: #fffdf3;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .2);
}
.m-user-popup-top {
  height: 76px;
  gap: 10px;
  align-items: center;
}
.m-user-popup-avatar-wrapper {
  position: relative;
  width: 72px;
  height: 72px;
  padding: 0;
  border: 0;
  overflow: visible;
}
.m-user-popup-avatar {
  position: absolute;
  left: 14%;
  top: 14%;
  width: 72%;
  height: 72%;
  border-radius: 50%;
  object-fit: cover;
}
.m-user-popup-avatar-frame {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}
.m-user-popup-details {
  gap: 4px;
  justify-content: center;
}
.m-user-popup-name-row {
  gap: 6px;
}
.m-user-popup-name {
  max-width: 150px;
  overflow: hidden;
  font-size: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.m-user-popup-edit {
  width: 17px;
  height: 17px;
  object-fit: contain;
  cursor: pointer;
}
.m-user-popup-avatar-edit {
  position: absolute;
  right: 1px;
  bottom: 1px;
  z-index: 4;
  width: 18px;
  height: 18px;
  object-fit: contain;
  cursor: pointer;
}
.m-user-popup-badges {
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 25px;
}
.m-user-popup-vip {
  width: auto;
  height: 18px;
}
.m-user-popup-title {
  width: auto;
  max-width: 135px;
  height: 28px;
  object-fit: contain;
  object-position: left center;
}
.m-user-popup-exp {
  display: block;
  margin: 0;
}
.m-exp-bar-wrapper {
  width: 78%;
  height: 11px;
  overflow: hidden;
  border: 1px solid #082b50;
  border-radius: 7px;
  background: #164673;
}
.m-exp-bar-inner-container {
  position: static;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #f3a247 0%, #ffe46c 75%, #fffbd4 100%);
  box-shadow: 0 0 5px #fff16c;
}
.m-exp-text {
  margin-top: 3px;
  padding: 0;
  color: #40362d;
  background: transparent;
  font-size: 9px;
  line-height: 1;
}
</style>
